import { actionTypes } from '../../constants/actionTypes';
import {
  TThunkDispatch,
  IThunkContext,
  IApplicationState,
  EFeedbackScreen,
  ISendFeedbackParams,
} from '../../types/redux';
import {
  fetchAddAnalyticsOrder,
  IAddAnalyticsOrderResponse200,
  IAddAnalyticsOrderResponse400,
} from '../../repositories/valuation-b2b/v2/add-analytics-order';

import { trackSendFormSuccess } from './tracking';

export interface IFeedbackSetDimensionsAction {
  type: actionTypes.SET_DIMENSIONS_FEEDBACK;
  payload: {
    top: number;
    height: number;
  };
}

export interface IFeedbackToggleLoadAction {
  type: actionTypes.TOGGLE_LOAD_FEEDBACK;
  payload: boolean;
}

export interface IFeedbackToggleScreenAction {
  type: actionTypes.TOGGLE_SCREEN_FEEDBACK;
  payload: EFeedbackScreen;
}

export interface IFeedbackSetSendErrorAction {
  type: actionTypes.SET_SEND_ERROR_FEEDBACK;
}

export type TFeedbackActions =
  | IFeedbackSetDimensionsAction
  | IFeedbackToggleScreenAction
  | IFeedbackSetSendErrorAction
  | IFeedbackToggleLoadAction;

export function setDimensionsFeedback(top: number, height: number): IFeedbackSetDimensionsAction {
  return {
    type: actionTypes.SET_DIMENSIONS_FEEDBACK,
    payload: { top, height },
  };
}

export function toggleLoadFeedback(load: boolean): IFeedbackToggleLoadAction {
  return {
    type: actionTypes.TOGGLE_LOAD_FEEDBACK,
    payload: load,
  };
}

export function toggleScreenFeedback(screen: EFeedbackScreen): IFeedbackToggleScreenAction {
  return {
    type: actionTypes.TOGGLE_SCREEN_FEEDBACK,
    payload: screen,
  };
}

export function setErrorFeedback(): IFeedbackSetSendErrorAction {
  return {
    type: actionTypes.SET_SEND_ERROR_FEEDBACK,
  };
}

export function sendFeedback({ name, phone, email, comment }: ISendFeedbackParams) {
  return (dispatch: TThunkDispatch, getState: () => IApplicationState, context: IThunkContext) => {
    dispatch(toggleLoadFeedback(true));

    return fetchAddAnalyticsOrder<IAddAnalyticsOrderResponse200, IAddAnalyticsOrderResponse400>({
      httpApi: context.httpApi,
      parameters: { name, phone, comment, email, host: location.host },
    })
      .then(response => {
        dispatch(toggleLoadFeedback(false));

        if (response.statusCode === 200) {
          dispatch(toggleScreenFeedback(EFeedbackScreen.Thanks));

          trackSendFormSuccess();

          return;
        }

        dispatch(setErrorFeedback());
      })
      .catch(error => {
        context.logger.error(error, { message: 'Browser error /v2/add-analytics-order/' });

        dispatch(setErrorFeedback());
      });
  };
}
